import $ from 'jquery'
import Dragdealer from 'dragdealer';
import { arrayFromPolyfill } from './polyfills'
// enablePreloader();
arrayFromPolyfill();

let s__bars = Array.from(document.querySelectorAll('.content-scroller'));
let s__service_included = Array.from(document.querySelectorAll('.service__included'));
export function DragdealerInitBulk() {

  bars.forEach((x) => {
    createDragdealer(x);
  })
}

export function DragdealerInit(index) {
  var li_length = $(s__service_included[index]).find('li').length;
  // if( li_length > 6 ) {
  //   createDragdealer(s__bars[index]);
  // }
  // $(".service-content__mask").customScrollbar();
}

function createDragdealer(el) {
  if(el.dataset.initialized) {
    return;
  }
  let maskEl = el.parentElement.querySelector('.service-content__mask'),
      bodyEl = maskEl.querySelector('.service-content__body'),
      yy = 0,
      liElems = maskEl.querySelectorAll('.service__included-item'),
      length = liElems.length,
      l = bodyEl.offsetHeight / length,
      p = l / bodyEl.offsetHeight;

  let availHeight = bodyEl.offsetHeight - maskEl.offsetHeight;
  let scr = new Dragdealer(el, {
    horizontal: true,
    vertical: false,
    yPrecision: availHeight,
    animationCallback: function(x, y) {
      bodyEl.style.transform = 'translateY(' + (-x * availHeight) + 'px)';
      // console.log(x / p);

      let index = Math.floor(x / p);
      let activeElement = liElems[index];
      if(index === length) {
        return;
      }

      Array.from(activeElement.parentElement.children).forEach(x => {
        x.classList.remove('service__header-divider');
      });
      activeElement.classList.add('service__header-divider')
      
    }
  });

  bodyEl.addEventListener('mousewheel',(e) => {

      var delta = e.deltaY || e.detail || e.wheelDelta;

      if(delta > 0) {
        yy += 0.02;
      } else {
        yy -= 0.02;
      }

      if(yy > 1.1 ) {
        yy = 1;
      } else if( yy < -0.1) {
        yy = 0;
      } else {
        scr.setValue(yy, 0);
        event.preventDefault();
      }

  });
  el.dataset.initialized = true;
}

// let liElems = maskEl.querySelectorAll('.service__included li');
// let activeElement = liElems[index];
//
//
// $(document).on('click','.service__included li', function () {
//   let currentId = $(this).data('id');
//   let partnerElements = $(activeElement).closest('.service__flex_content').find('.service__partners');
//   let currentPartner = $(activeElement).closest('.service__flex_content').find('.service__partners[data-id="'+currentId+'"]');
//   if (! currentPartner.hasClass('active')) {
//     partnerElements.removeClass('active');
//     currentPartner.addClass('active');
//   }
// });



// WEBPACK FOOTER //
// ./src/js/custom-slider.js